import { MAX_TOKEN_AGE_IN_MS } from "@repo/constants/common";

export const mapUserToToken = (user) => {
  return {
    name: user.firstName,
    lastName: user.lastName,
    phoneNumber: user.phoneNumber,
    accessToken: user.token,
    refreshToken: user.refreshToken,
    customerId: user.customerId,
    tokenExpiryTime: Date.now() + MAX_TOKEN_AGE_IN_MS,
    refreshTokenExpiryTime: user.refreshTokenExpiryTime,
    createdAt: user.createdAt,
    socialType: user.socialType ?? "none",
  };
};

export const mapTokenToSession = (session, token) => {
  session.user = {
    ...session.user,
    name: token.name,
    lastName: token.lastName,
    phoneNumber: token.phoneNumber,
    accessToken: token.accessToken,
    refreshToken: token.refreshToken,
    customerId: token.customerId,
    tokenExpiryTime: token.tokenExpiryTime,
    refreshTokenExpiryTime: token.refreshTokenExpiryTime,
    createdAt: token.createdAt,
    socialType: token.socialType ?? "none",
  };
  return session;
};
